<template>
  <div class="align-middle">
    <p class="q-mb-none">
      <PEditable
        :model-value="col.value || tableProps.value || 0"
        :type="col.type"
        disable
      />
    </p>
    <p class="q-mb-xs text-xxs text-neutral-70 text-italic text-nowrap">
      (exc. tax)
    </p>
    <p class="q-mb-none">
      <PEditable
        :model-value="tableProps.row.amount_wt || 0"
        :type="col.type"
        disable
      />
    </p>
    <p class="q-mb-none text-xxs text-neutral-70 text-italic text-nowrap">
      (inc. tax)
    </p>
  </div>
</template>

<script setup>
defineProps({
  col: {
    type: Object,
    default: () => {
      return {};
    },
  },
  tableProps: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>
